import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DataSharingService {
  public isLoginChanged: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public isProfileChanged: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public isPermissionChanged: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public userAvatar: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public searchParam: BehaviorSubject<any> = new BehaviorSubject<any>("");
  public searchEmpty: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public headerProfile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public notificationHeader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public notificationPage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  public notificationData: BehaviorSubject<boolean> = new BehaviorSubject<any>(null);
  public newMessageRecive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public clearNotification: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  getCurrentUser() {
    return localStorage.getItem("userName");
  }

  getUserType() {
    return localStorage.getItem("userType");
  }

  setUserAvatar(value: any) {
    localStorage.setItem("userAvatar", value);
    this.userAvatar.next(value);
  }

  searchFaq(query: string) {
    // console.log("query------", query);
    this.searchParam.next(query);
  }
  formateAmount(value: any) {
  if(!value){
    return 0
  }
  let [integer, decimal] = value.toString().split('.');

  integer = integer || '';
  if (decimal) decimal = decimal;
  integer = Number(integer || 0).toLocaleString('en-US');

  const formatted = decimal ? `${integer}.${decimal}` : integer;
  return formatted;
}
formatedAmountEvent(event: any) {
  
  if(event.target.value.endsWith('.')){
    return
  }
  let value = event.target.value.replace(/,/g, '');
  let [integer, decimal] = value.split('.');

  integer = integer || '';
  if (decimal) decimal = decimal;
  integer = Number(integer || 0).toLocaleString('en-US');

  const formatted = decimal ? `${integer}.${decimal}` : integer;
  event.target.value = formatted;
}
}
